import React from 'react';
import classNames from 'clsx';
import { Scrollbars } from 'react-custom-scrollbars-2';

import { SelectOptionsPaperProps } from './SelectOptionsPaper.interface';
import { useStyles } from './SelectOptionsPaper.styles';

export default function SelectOptionsPaper({
  children,
  className,
  style,
}: SelectOptionsPaperProps) {
  const classes = useStyles();

  return (
    <Scrollbars
      tabIndex={-1}
      autoHeight
      autoHeightMin={0}
      autoHeightMax={'45vh'}
      className={classNames(classes.root, className)}
      style={{ ...style, position: 'absolute' }}
      aria-label={'select options'}
    >
      {children}
    </Scrollbars>
  );
}
